"use strict";
/*
 * Original script author: ScriptedAlchemy <zackary.l.jackson@gmail.com>
 * https://gist.github.com/ScriptedAlchemy/3a24008ef60adc47fad1af7d3299a063
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrLoadRemote = void 0;
const events_1 = require("./module-registry/events");
const loadingState = {
    status: 'isLoading',
    instances: 1
};
const traceId = '17ae32ca-770e-49e7-b5dc-722ca061ce68';
const getOrLoadRemote = (scope, url) => new Promise((resolve, reject) => {
    const onload = () => __awaiter(void 0, void 0, void 0, function* () {
        // @ts-ignore
        if (!window[scope].__initialized) {
            // @ts-ignore
            yield window[scope].init(__webpack_share_scopes__.default);
            // @ts-ignore
            window[scope].__initialized = true;
        }
        (0, events_1.setModuleStatus)({ moduleName: scope, status: 'ready' });
        resolve();
    });
    const onerror = () => {
        const errMessage = `Dynamic Script Error: ${url}`;
        console.error(errMessage);
        (0, events_1.setModuleError)({
            moduleName: scope,
            error: { message: errMessage, url, scope, traceId }
        });
        reject();
    };
    // @ts-ignore
    if (!window[scope]) {
        const existingRemote = document.querySelector(`[data-webpack="${scope}"]`);
        if (existingRemote) {
            const existingOnload = existingRemote.onload;
            const existingOnerror = existingRemote.onerror;
            existingRemote.onload = () => __awaiter(void 0, void 0, void 0, function* () {
                existingOnload();
                (0, events_1.addModuleInstance)({
                    moduleName: scope
                });
                resolve();
            });
            existingRemote.onerror = () => {
                existingOnerror();
                reject();
            };
        }
        else if (url) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.setAttribute('data-webpack', scope);
            script.async = true;
            script.onerror = onerror;
            script.onload = onload;
            script.src = url;
            (0, events_1.setModuleState)({ moduleName: scope, moduleState: loadingState });
            document.head.appendChild(script);
        }
        else {
            reject(`Cannot Find Remote ${scope} to inject`);
        }
    }
    else {
        (0, events_1.addModuleInstance)({
            moduleName: scope
        });
        resolve();
    }
});
exports.getOrLoadRemote = getOrLoadRemote;
